import React from "react";
import SignUpForm from "../Components/SignUpForm";

export default function SignUp() {
  return (
    <div className="auth-page">
      <SignUpForm />
    </div>
  );
}
